export default __webpack_public_path__ + "static/media/flag.d8d8a0a4.svg";